/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   ____  ____   ___  
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| |  _ \|  _ \ / _ \ 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || |  | |_) | |_) | | | |
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |  |  __/|  _ <| |_| |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___| |_|   |_| \_\\___/ 
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.horizon-ui.com/pro/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Flex, Text } from "@chakra-ui/react";
// Custom components
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Order from "../../order";
import {
  SelectChartData,
  SelectDashboardFormData,
  selectEndDate,
  selectFilterValue,
  selectStartDate,
} from "../redux/selector";
import { actions } from "../redux/slice";
import DataBox from "./new-component/data-box";
import Filter from "./new-component/filter";
import Graph from "./new-component/graph";
import Card from "../../../../components/card/Card";
import { useTranslation } from "react-i18next";

export default function Default() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const endDate = useSelector(selectEndDate);
  const startDate = useSelector(selectStartDate);
  const filterValue = useSelector(selectFilterValue);
  const data = useSelector(SelectDashboardFormData);
  const chartData = useSelector(SelectChartData);

  useEffect(() => {
    dispatch(actions.doGetDashboardList());
    dispatch(actions.getDashboardChartData());

    return () => {};
  }, [filterValue, endDate]);

  return (
    <Flex
      direction={{ base: "column" }}
      pt={{ base: "130px", md: "80px", xl: "80px" }}
    >
      <Filter
        filterValue={filterValue}
        startDate={startDate}
        endDate={endDate}
      />
      <DataBox data={data} />
      <Graph data={chartData} />
      <Card sx={{ mt: 4 }}>
        <Flex paddingBottom="-80px">
          <Text
            fontSize={["sm", "md", "lg"]} // Font size decreases as screen size decreases
            lineHeight="10"
            fontWeight="400"
            
          >
            {t("dashboard.recentOrder")}
          </Text>
        </Flex>
        <Order hideFilter />
      </Card>
    </Flex>
  );
}
